var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w3-container"},[_c('HomepageTitle'),_c('p',{staticClass:"w3-center",attrs:{"id":"menu"}},[_vm._v(" "+_vm._s(_vm.$t('selectFunctionViaNavigation'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }